import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import GroupStafModal from "../components/GroupStafModal";
import ActiveButton from "../../../../CommonElements/Button/ActiveButton";

const GroupStafColumns = (
  resetState,
  toggleDetail,
  updateSelectedGroupStaf,
  toggleActivate
) => [
  {
    name: <DataTableTitle text={"Group Staf"} />,
    selector: (row) => (
      <div
        className="text-primary"
        style={{ cursor: "pointer" }}
        onClick={() => {
          toggleDetail();
          updateSelectedGroupStaf(row);
        }}
      >
        {row.nama}
      </div>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Email Pimpinan"} />,
    selector: (row) => row.email_pimpinan,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Operasi"} />,
    width: "15%",
    cell: (row) => (
      <div>
        <GroupStafModal create={false} data={row} resetState={resetState} />
        &nbsp;&nbsp;
        <ActiveButton
          isActive={Boolean(row?.is_active)}
          toggle={() => toggleActivate(row?.id_group)}
        />
      </div>
    ),
  },
];

export default GroupStafColumns;
